import React from "react";
import { Grid, Segment, Container } from "semantic-ui-react";

const Footer = () => {
  return (
    <Grid inverted textAlign="left" style={{ padding: "5em 0em 0em 0em" }}>
      <Grid.Row>
        <Grid.Column width={16}>
          <Segment inverted vertical style={{ padding: "0em 0em" }}>
            <Container>
              <Grid divided inverted stackable>
                <Grid.Row>
                  <Grid.Column width={3}>
                    <strong>Contact:</strong> donalireland@gmail.com
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <strong>bridgemate.ie</strong>
                    <br />
                    <p>Home for regional bridge results, fixtures and news.</p>
                  </Grid.Column>
                  <Grid.Column width={10}>
                    <strong>FOR YOUR INFORMATION</strong>
                    <br />

                    <p>General Data Protection Regulations:</p>
                    <p>
                      {" "}
                      The General Data Protection Regulations (GDPR) is a new EU
                      regulation which came into effect on 25th May 2018. It
                      updates existing data protection laws and gives the
                      individual greater control over their personal
                      information.
                    </p>
                    <p>
                      {" "}
                      <strong>All members of Bridge Clubs</strong> will be
                      requested to complete a new membership form on
                      commencement of the new bridge year (2021/22).
                    </p>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Container>
          </Segment>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default Footer;
